import LearnPageLayout from "@/components/LearnPageLayout";
import { pageSaintBocaRaton } from "./learnDataSaintBocaRaton";

const SaintBocaRatonPage = () => (
  <LearnPageLayout
    title={pageSaintBocaRaton.title}
    description={pageSaintBocaRaton.description}
    canonical={pageSaintBocaRaton.canonical}
    h1={pageSaintBocaRaton.h1}
    breadcrumbLabel={pageSaintBocaRaton.breadcrumbLabel}
    crumbs={pageSaintBocaRaton.crumbs}
    shortAnswer={pageSaintBocaRaton.shortAnswer}
    keyTakeaways={pageSaintBocaRaton.keyTakeaways}
    sections={pageSaintBocaRaton.sections}
    faqs={pageSaintBocaRaton.faqs}
    sources={pageSaintBocaRaton.sources}
    schemaJson={pageSaintBocaRaton.schemaJson}
    relatedLinks={pageSaintBocaRaton.relatedLinks}
    reviewBlock={pageSaintBocaRaton.reviewBlock}
  />
);

export default SaintBocaRatonPage;
